import React, { useState } from "react";
import StepScreenshot from "./stepScreenshot";
import ScreenshotsSlideshow from "./screenshotsSlideshow";
import { Remarkable } from "remarkable";

const markdown = new Remarkable();

const NewUsers = ({ content = {} }) => {
  const { title, subtitle, description, steps = [] } = content;
  const [selectedLine, setSelectedLine] = useState(1);

  return (
    <div id="newUsers">
      <div className="header">
        <h3>{title}</h3>
        <h2>{subtitle}</h2>
        <p dangerouslySetInnerHTML={{ __html: markdown.render(description) }} />
      </div>
      <div className="left">
        <div className="content">
          <ul>
            {steps.map(({ content: stepDescription }, i) => (
              <li key={i}>
                <StepScreenshot
                  index={i + 1}
                  currentIndex={selectedLine}
                  changeIndex={setSelectedLine}
                  text={stepDescription}
                />
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="right">
        <ScreenshotsSlideshow
          images={steps.map(({ image }) => image)}
          currentIndex={selectedLine - 1}
          keyName="newUsers"
        />
      </div>
    </div>
  );
};

export default NewUsers;
